import { render, staticRenderFns } from "./AppModalCustomer.vue?vue&type=template&id=4e709b94&scoped=true&"
import script from "./AppModalCustomer.vue?vue&type=script&lang=js&"
export * from "./AppModalCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e709b94",
  null
  
)

export default component.exports